import { render, staticRenderFns } from "./DSRegionSelect.vue?vue&type=template&id=c685080c&"
import script from "./DSRegionSelect.vue?vue&type=script&lang=js&"
export * from "./DSRegionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports